import * as React from 'react'
import clx from 'classnames'

import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { SubNavigationBar } from '../shared/components'
import { SettingsIcon } from '@/app/features/icons/Settings'
import { useRaportForm } from './context/RaportFormContext'
import { ActiveMenuItem } from '@/app/constants/menuItem'
import { SubNavigationButton } from '../shared/components/SubNavigationButton'
import { HeadBar } from './components/HeadBar'
import { PrintJobOverlay } from './components/PrintJobOverlay'
import { DatePickerRangeProps } from '@/modules/drivers/types'

type Props = {
  children: React.ReactNode
  companyId: string
  viewControlBar?: () => React.JSX.Element
  heightScreen?: boolean
  fullScreen?: boolean
}

export const PrintoutLayout = ({
  children,
  viewControlBar: ViewControlBar,
  heightScreen = false,
  fullScreen = false,
}: Props) => {
  const { t } = useLocalize()

  const baseClasses = clx(
    'module-printouts tw-flex tw-flex-[1] tw-flex-col tw-overflow-hidden tw-text-content-base tw-bg-base-100 tw-min-w-0 tw-max-w-full',
    {
      'tw-h-screen': fullScreen,
      'tw-padding-4 tw-mt-1 tw-mb-1 tw-rounded-xl tw-border tw-border-base-300':
        !fullScreen,
      'tw-max-h-[calc(100vh-8px)]': !fullScreen && heightScreen,
      'tw-min-h-[calc(100vh-8px)]': !fullScreen && !heightScreen,
    },
  )
  const boundaryRef = React.useRef<HTMLDivElement>(null)
  const {
    driverMode,
    setDriverMode,
    dateRange,
    setDateRange,
    setOutputType,
    outputType,
  } = useRaportForm()

  const handleDateRangeChange = React.useCallback(
    (newRange: DatePickerRangeProps) => {
      setDateRange(newRange)
    },
    [setDateRange],
  )

  return (
    <div className={baseClasses} ref={boundaryRef}>
      <HeadBar
        setOutputType={setOutputType}
        outputType={outputType}
        title={t('dashboard.printouts')}
        icon={<SettingsIcon />}
        handleDateRangeChange={handleDateRangeChange}
        range={dateRange}
      />
      <SubNavigationBar>
        <SubNavigationButton
          isActive={driverMode === ActiveMenuItem.PRINTOUT_DRIVER}
          onClick={() => setDriverMode(ActiveMenuItem.PRINTOUT_DRIVER)}
        >
          {t('printout.drivers')}
        </SubNavigationButton>
        <SubNavigationButton
          isActive={driverMode === ActiveMenuItem.PRINTOUT_VEHICLE}
          onClick={() => setDriverMode(ActiveMenuItem.PRINTOUT_VEHICLE)}
        >
          {t('printout.vehicles')}
        </SubNavigationButton>
      </SubNavigationBar>

      {ViewControlBar && <ViewControlBar />}
    <main
          className={`tw-flex tw-w-full tw-flex-1 ${heightScreen ? 'tw-max-h-screen tw-flex-col tw-overflow-hidden' : ''} `}
        >
          {children}
        </main>
      <PrintJobOverlay />
    </div>
  )
}
